import React from 'react'
import { useLayout } from '../layout/core'
import { useQuery } from '@apollo/client'
import { GET_WHITE_LABELING_BY_ID } from '../graphql/query'
import { usePlan } from '../context/PlanContext'

const Footer: React.FC = () => {
  const { classes } = useLayout()
  const { currentPlan } = usePlan()

  const { data, loading, error } = useQuery(GET_WHITE_LABELING_BY_ID, {
    variables: {
      input: {
        bgAccountId: currentPlan?.bgAccountId
      }
    }
  })

  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-center`}
      >
        {/* begin::Copyright */}
        <div className='text-dark order-2 order-md-1'>
          <span className='text-muted fw-bold me-2'>
            &copy; Copyright {new Date().getFullYear()} &nbsp;
            <a
              href={data?.getWhiteLabelingbyId[0]?.copyright || 'https://globtierinfotech.com'}
              className='text-gray-500 text-hover-primary'
            >
              {data?.getWhiteLabelingbyId[0]?.companyName ||
                'Botgo Technologies Pvt Ltd. (by Globtier)'}{' '}
              &nbsp;
            </a>
            All Rights Reserved
          </span>
        </div>
        {/* end::Copyright */}
      </div>
      {/* end::Container */}
    </div>
  )
}

export default Footer
